module.exports = Typekit;